import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoTelegram = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.639 17.487c6.802-2.954 11.33-4.917 13.605-5.87 6.472-2.7 7.833-3.167 8.707-3.187.194 0 .622.039.914.272.233.195.291.447.33.642.039.194.078.602.039.913-.35 3.693-1.866 12.653-2.643 16.773-.33 1.75-.972 2.333-1.594 2.39-1.36.118-2.39-.893-3.693-1.748-2.06-1.341-3.207-2.177-5.209-3.499-2.313-1.516-.816-2.351.506-3.712.35-.35 6.316-5.792 6.433-6.278.02-.058.02-.291-.117-.408-.136-.117-.33-.078-.486-.039-.213.039-3.479 2.216-9.834 6.511-.933.642-1.769.953-2.527.933-.836-.02-2.43-.466-3.634-.855-1.458-.466-2.624-.72-2.527-1.535.058-.428.641-.856 1.73-1.303",
		clipRule: "evenodd"
	})
});
export default SvgIcoTelegram;
